// Configuración de plantillas para exportación a PDF
// Este archivo contiene todas las configuraciones personalizables para PDF

const pdfTemplates = {
  // Plantilla estándar
  standard: {
    nombre: 'Estándar',
    descripcion: 'Formato básico de presupuesto en PDF',

    // Configuración de página
    pagina: {
      formato: 'letter', // 'letter', 'a4', 'legal'
      orientacion: 'portrait', // 'portrait' o 'landscape'
      margenes: {
        top: 20,
        bottom: 20,
        left: 20,
        right: 20
      },
      numeracion: true,
      numeracionFormato: 'Página {page} de {pages}'
    },

    // Estilos de texto
    estilos: {
      titulo: {
        fontSize: 18,
        fontStyle: 'bold',
        alignment: 'center',
        color: '#000000',
        marginBottom: 10
      },
      subtitulo: {
        fontSize: 14,
        fontStyle: 'bold',
        alignment: 'left',
        color: '#333333',
        marginBottom: 5
      },
      encabezadoTabla: {
        fontSize: 11,
        fontStyle: 'bold',
        fillColor: [68, 114, 196], // RGB
        textColor: [255, 255, 255],
        alignment: 'center'
      },
      celdaTabla: {
        fontSize: 10,
        textColor: [0, 0, 0],
        alignment: 'left'
      },
      celdaNumerica: {
        fontSize: 10,
        textColor: [0, 0, 0],
        alignment: 'right'
      },
      total: {
        fontSize: 12,
        fontStyle: 'bold',
        textColor: [0, 0, 0],
        fillColor: [230, 230, 230],
        alignment: 'right'
      },
      piePagina: {
        fontSize: 9,
        fontStyle: 'italic',
        color: '#666666',
        alignment: 'center'
      }
    },

    // Configuración del encabezado
    encabezado: {
      mostrar: true,
      altura: 70,
      contenido: {
        titulo: 'PRESUPUESTO DE OBRA',
        mostrarLogo: false,
        logoUrl: null,
        logoPosicion: 'izquierda', // 'izquierda', 'centro', 'derecha'
        logoAncho: 60,
        logoAlto: 30
      },
      campos: [
        { campo: 'nombre_obra', etiqueta: 'Obra:', mostrar: true, fila: 1 },
        { campo: 'cliente', etiqueta: 'Cliente:', mostrar: true, fila: 2 },
        { campo: 'ubicacion', etiqueta: 'Ubicación:', mostrar: true, fila: 3 },
        { campo: 'fecha_elaboracion', etiqueta: 'Fecha:', mostrar: true, fila: 4, formato: 'fecha' }
      ],
      estilo: {
        fontSize: 10,
        lineHeight: 1.5
      }
    },

    // Configuración de tabla de conceptos
    tabla: {
      tema: 'grid', // 'striped', 'grid', 'plain'
      startY: 75,
      columnas: [
        { campo: 'codigo', titulo: 'Código', ancho: 'auto', alinear: 'left' },
        { campo: 'descripcion', titulo: 'Descripción', ancho: 'auto', alinear: 'left' },
        { campo: 'unidad', titulo: 'Unidad', ancho: 'auto', alinear: 'center' },
        { campo: 'cantidad', titulo: 'Cantidad', ancho: 'auto', alinear: 'right' },
        { campo: 'precio_unitario', titulo: 'P.U.', ancho: 'auto', alinear: 'right', formato: 'moneda' },
        { campo: 'importe', titulo: 'Importe', ancho: 'auto', alinear: 'right', formato: 'moneda' }
      ],
      estilos: {
        cellPadding: 2,
        fontSize: 10,
        lineColor: [0, 0, 0],
        lineWidth: 0.1,
        fillColor: function(rowIndex) {
          return rowIndex % 2 === 0 ? [245, 245, 245] : null;
        }
      },
      mostrarTotales: false // Los totales se muestran aparte
    },

    // Configuración de totales
    totales: {
      mostrar: true,
      posicion: 'despuesTabla', // 'despuesTabla' o 'piePagina'
      espacioAntes: 10,
      alineacion: 'derecha', // 'izquierda', 'centro', 'derecha'
      anchoEtiqueta: 120,
      campos: [
        { campo: 'costoDirecto', etiqueta: 'Costo Directo:', mostrar: true, formato: 'moneda' },
        { campo: 'indirectos', etiqueta: 'Indirectos', mostrar: true, formato: 'moneda', mostrarPorcentaje: true },
        { campo: 'financiamiento', etiqueta: 'Financiamiento', mostrar: true, formato: 'moneda', mostrarPorcentaje: true },
        { campo: 'utilidad', etiqueta: 'Utilidad', mostrar: true, formato: 'moneda', mostrarPorcentaje: true },
        { campo: 'subtotal', etiqueta: 'Subtotal:', mostrar: true, formato: 'moneda', separador: true },
        { campo: 'iva', etiqueta: 'IVA', mostrar: true, formato: 'moneda', mostrarPorcentaje: true },
        { campo: 'total', etiqueta: 'TOTAL:', mostrar: true, formato: 'moneda', resaltar: true }
      ]
    },

    // Configuración del pie de página
    piePagina: {
      mostrar: true,
      altura: 30,
      contenido: {
        texto: 'Generado por Sistema de Presupuestación v2.0',
        mostrarFecha: true,
        mostrarPagina: true
      }
    }
  },

  // Plantilla detallada
  detallada: {
    nombre: 'Detallada',
    descripcion: 'Formato con análisis de precios unitarios',

    pagina: {
      formato: 'letter',
      orientacion: 'landscape', // Horizontal para más columnas
      margenes: {
        top: 15,
        bottom: 15,
        left: 15,
        right: 15
      },
      numeracion: true
    },

    estilos: {
      titulo: {
        fontSize: 16,
        fontStyle: 'bold',
        alignment: 'center',
        color: '#1a472a',
        marginBottom: 8
      },
      subtitulo: {
        fontSize: 12,
        fontStyle: 'bold',
        alignment: 'left',
        color: '#2e5266',
        marginBottom: 5
      },
      encabezadoTabla: {
        fontSize: 10,
        fontStyle: 'bold',
        fillColor: [46, 82, 102],
        textColor: [255, 255, 255],
        alignment: 'center'
      },
      celdaTabla: {
        fontSize: 9,
        textColor: [0, 0, 0],
        alignment: 'left'
      },
      analisis: {
        fontSize: 8,
        textColor: [70, 70, 70],
        fontStyle: 'italic',
        fillColor: [255, 249, 230]
      }
    },

    encabezado: {
      mostrar: true,
      altura: 60,
      contenido: {
        titulo: 'PRESUPUESTO DETALLADO DE OBRA',
        mostrarLogo: false
      },
      campos: [
        { campo: 'nombre_obra', etiqueta: 'Proyecto:', mostrar: true },
        { campo: 'cliente', etiqueta: 'Cliente:', mostrar: true },
        { campo: 'ubicacion', etiqueta: 'Ubicación:', mostrar: true },
        { campo: 'fecha_elaboracion', etiqueta: 'Fecha:', mostrar: true, formato: 'fecha' },
        { campo: 'elaboro', etiqueta: 'Elaboró:', mostrar: true }
      ]
    },

    tabla: {
      tema: 'grid',
      startY: 65,
      columnas: [
        { campo: 'partida', titulo: 'Partida', ancho: 15, alinear: 'center' },
        { campo: 'codigo', titulo: 'Código', ancho: 20, alinear: 'left' },
        { campo: 'descripcion', titulo: 'Descripción', ancho: 60, alinear: 'left' },
        { campo: 'unidad', titulo: 'Un.', ancho: 10, alinear: 'center' },
        { campo: 'cantidad', titulo: 'Cant.', ancho: 15, alinear: 'right' },
        { campo: 'precio_unitario', titulo: 'P.U.', ancho: 20, alinear: 'right', formato: 'moneda' },
        { campo: 'materiales', titulo: 'Mat.', ancho: 20, alinear: 'right', formato: 'moneda' },
        { campo: 'mano_obra', titulo: 'M.O.', ancho: 20, alinear: 'right', formato: 'moneda' },
        { campo: 'maquinaria', titulo: 'Maq.', ancho: 20, alinear: 'right', formato: 'moneda' },
        { campo: 'importe', titulo: 'Importe', ancho: 25, alinear: 'right', formato: 'moneda' }
      ],
      incluirAnalisis: true,
      estilos: {
        cellPadding: 1.5,
        fontSize: 9,
        lineColor: [100, 100, 100],
        lineWidth: 0.1
      }
    },

    totales: {
      mostrar: true,
      incluirDesglose: true,
      campos: [
        { campo: 'totalMateriales', etiqueta: 'Total Materiales:', mostrar: true, formato: 'moneda' },
        { campo: 'totalManoObra', etiqueta: 'Total Mano de Obra:', mostrar: true, formato: 'moneda' },
        { campo: 'totalMaquinaria', etiqueta: 'Total Maquinaria:', mostrar: true, formato: 'moneda' },
        { campo: 'costoDirecto', etiqueta: 'Costo Directo:', mostrar: true, formato: 'moneda', separador: true },
        { campo: 'indirectos', etiqueta: 'Indirectos', mostrar: true, formato: 'moneda', mostrarPorcentaje: true },
        { campo: 'financiamiento', etiqueta: 'Financiamiento', mostrar: true, formato: 'moneda', mostrarPorcentaje: true },
        { campo: 'utilidad', etiqueta: 'Utilidad', mostrar: true, formato: 'moneda', mostrarPorcentaje: true },
        { campo: 'subtotal', etiqueta: 'Subtotal:', mostrar: true, formato: 'moneda' },
        { campo: 'iva', etiqueta: 'IVA', mostrar: true, formato: 'moneda', mostrarPorcentaje: true },
        { campo: 'total', etiqueta: 'TOTAL:', mostrar: true, formato: 'moneda', resaltar: true }
      ]
    }
  },

  // Plantilla ejecutiva
  ejecutiva: {
    nombre: 'Ejecutiva',
    descripcion: 'Formato profesional para presentación',

    pagina: {
      formato: 'letter',
      orientacion: 'portrait',
      margenes: {
        top: 25,
        bottom: 25,
        left: 25,
        right: 25
      },
      numeracion: true,
      numeracionFormato: '{page}'
    },

    estilos: {
      titulo: {
        fontSize: 20,
        fontStyle: 'bold',
        alignment: 'center',
        color: '#2c3e50',
        marginBottom: 15
      },
      subtitulo: {
        fontSize: 14,
        fontStyle: 'normal',
        alignment: 'center',
        color: '#7f8c8d',
        marginBottom: 20
      },
      encabezadoTabla: {
        fontSize: 11,
        fontStyle: 'bold',
        fillColor: [44, 62, 80],
        textColor: [255, 255, 255],
        alignment: 'center'
      },
      celdaTabla: {
        fontSize: 10,
        textColor: [52, 73, 94],
        alignment: 'left',
        lineHeight: 1.2
      }
    },

    encabezado: {
      mostrar: true,
      altura: 100,
      contenido: {
        titulo: 'PROPUESTA ECONÓMICA',
        subtitulo: 'Presupuesto de Obra',
        mostrarLogo: true,
        logoUrl: null,
        logoPosicion: 'centro',
        logoAncho: 80,
        logoAlto: 40
      },
      campos: [
        { campo: 'folio', etiqueta: 'Folio:', mostrar: true, resaltar: true },
        { campo: 'nombre_obra', etiqueta: 'Proyecto:', mostrar: true },
        { campo: 'cliente', etiqueta: 'Cliente:', mostrar: true },
        { campo: 'ubicacion', etiqueta: 'Ubicación:', mostrar: true },
        { campo: 'fecha_elaboracion', etiqueta: 'Fecha:', mostrar: true, formato: 'fechaCompleta' },
        { campo: 'vigencia', etiqueta: 'Vigencia:', mostrar: true }
      ],
      cuadroInfo: true // Encerrar información en un cuadro
    },

    tabla: {
      tema: 'plain',
      startY: 110,
      columnas: [
        { campo: 'item', titulo: '#', ancho: 10, alinear: 'center' },
        { campo: 'descripcion', titulo: 'Concepto', ancho: 'auto', alinear: 'left' },
        { campo: 'cantidad', titulo: 'Cantidad', ancho: 20, alinear: 'right' },
        { campo: 'unidad', titulo: 'Unidad', ancho: 15, alinear: 'center' },
        { campo: 'precio_unitario', titulo: 'Precio Unitario', ancho: 30, alinear: 'right', formato: 'moneda' },
        { campo: 'importe', titulo: 'Importe', ancho: 30, alinear: 'right', formato: 'moneda' }
      ],
      agruparPorPartidas: true,
      estilos: {
        cellPadding: 3,
        fontSize: 10,
        lineColor: [200, 200, 200],
        lineWidth: 0.5,
        showHead: 'firstPage',
        alternateRowStyles: {
          fillColor: [245, 245, 245]
        }
      }
    },

    totales: {
      mostrar: true,
      posicion: 'despuesTabla',
      enCuadro: true,
      campos: [
        { campo: 'costoDirecto', etiqueta: 'COSTO DIRECTO:', mostrar: true, formato: 'moneda' },
        { campo: 'indirectos', etiqueta: 'Indirectos de Operación', mostrar: true, formato: 'moneda', mostrarPorcentaje: true },
        { campo: 'financiamiento', etiqueta: 'Costo por Financiamiento', mostrar: true, formato: 'moneda', mostrarPorcentaje: true },
        { campo: 'utilidad', etiqueta: 'Utilidad', mostrar: true, formato: 'moneda', mostrarPorcentaje: true },
        { campo: 'subtotal', etiqueta: 'SUBTOTAL:', mostrar: true, formato: 'moneda', separador: true },
        { campo: 'iva', etiqueta: 'I.V.A.', mostrar: true, formato: 'moneda', mostrarPorcentaje: true },
        { campo: 'total', etiqueta: 'IMPORTE TOTAL:', mostrar: true, formato: 'moneda', resaltar: true }
      ],
      incluirTextoTotal: true, // Incluir total en letra
      monedaTexto: 'PESOS'
    },

    piePagina: {
      mostrar: true,
      contenido: {
        firmas: true,
        espacioFirmas: [
          { titulo: 'Elaboró', nombre: '', espacio: 60 },
          { titulo: 'Revisó', nombre: '', espacio: 60 },
          { titulo: 'Autorizó', nombre: '', espacio: 60 }
        ],
        notas: [
          'Los precios incluyen materiales, mano de obra, herramienta y equipo.',
          'Vigencia del presupuesto: 30 días naturales.',
          'No incluye I.E.P.S.'
        ],
        contacto: {
          mostrar: true,
          telefono: '(555) 123-4567',
          email: 'ventas@empresa.com',
          web: 'www.empresa.com'
        }
      }
    }
  },

  // Plantilla minimalista
  minimalista: {
    nombre: 'Minimalista',
    descripcion: 'Diseño limpio y moderno',

    pagina: {
      formato: 'a4',
      orientacion: 'portrait',
      margenes: {
        top: 30,
        bottom: 30,
        left: 40,
        right: 40
      },
      numeracion: false
    },

    estilos: {
      titulo: {
        fontSize: 24,
        fontStyle: 'normal',
        alignment: 'left',
        color: '#000000',
        marginBottom: 5
      },
      subtitulo: {
        fontSize: 12,
        fontStyle: 'normal',
        alignment: 'left',
        color: '#999999',
        marginBottom: 30
      },
      encabezadoTabla: {
        fontSize: 10,
        fontStyle: 'normal',
        fillColor: null,
        textColor: [150, 150, 150],
        alignment: 'left',
        borderBottom: [0, 0, 0]
      },
      celdaTabla: {
        fontSize: 10,
        textColor: [0, 0, 0],
        alignment: 'left',
        borderBottom: [230, 230, 230]
      }
    },

    encabezado: {
      mostrar: true,
      altura: 80,
      contenido: {
        titulo: 'Presupuesto',
        mostrarLogo: false
      },
      campos: [
        { campo: 'cliente', etiqueta: 'Para:', mostrar: true, sinNegrita: true },
        { campo: 'nombre_obra', etiqueta: 'Proyecto:', mostrar: true, sinNegrita: true },
        { campo: 'fecha_elaboracion', etiqueta: 'Fecha:', mostrar: true, formato: 'fecha', sinNegrita: true }
      ],
      estilo: {
        fontSize: 11,
        lineHeight: 2
      }
    },

    tabla: {
      tema: 'plain',
      startY: 90,
      columnas: [
        { campo: 'descripcion', titulo: 'Descripción', ancho: 'auto', alinear: 'left' },
        { campo: 'cantidad', titulo: 'Cant.', ancho: 20, alinear: 'right' },
        { campo: 'precio_unitario', titulo: 'Precio', ancho: 30, alinear: 'right', formato: 'moneda' },
        { campo: 'importe', titulo: 'Total', ancho: 35, alinear: 'right', formato: 'moneda' }
      ],
      estilos: {
        cellPadding: 5,
        fontSize: 10,
        showHead: 'firstPage',
        tableLineColor: [255, 255, 255],
        tableLineWidth: 0
      }
    },

    totales: {
      mostrar: true,
      posicion: 'despuesTabla',
      espacioAntes: 20,
      alineacion: 'derecha',
      campos: [
        { campo: 'subtotal', etiqueta: 'Subtotal', mostrar: true, formato: 'moneda' },
        { campo: 'iva', etiqueta: 'IVA (16%)', mostrar: true, formato: 'moneda' },
        { campo: 'total', etiqueta: 'Total', mostrar: true, formato: 'moneda', resaltar: true }
      ],
      estiloTotal: {
        fontSize: 14,
        fontStyle: 'bold'
      }
    },

    piePagina: {
      mostrar: false
    }
  }
};

// Función para obtener una plantilla específica
export const getPdfTemplate = (templateName = 'standard') => {
  return pdfTemplates[templateName] || pdfTemplates.standard;
};

// Función para obtener lista de plantillas disponibles
export const getAvailablePdfTemplates = () => {
  return Object.keys(pdfTemplates).map(key => ({
    id: key,
    nombre: pdfTemplates[key].nombre,
    descripcion: pdfTemplates[key].descripcion
  }));
};

// Función para personalizar una plantilla existente
export const customizePdfTemplate = (baseTemplate, customizations) => {
  const template = JSON.parse(JSON.stringify(pdfTemplates[baseTemplate] || pdfTemplates.standard));

  // Aplicar personalizaciones recursivamente
  const merge = (target, source) => {
    Object.keys(source).forEach(key => {
      if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
        target[key] = target[key] || {};
        merge(target[key], source[key]);
      } else {
        target[key] = source[key];
      }
    });
  };

  if (customizations) {
    merge(template, customizations);
  }

  return template;
};

// Configuración global de PDF
export const pdfConfig = {
  // Configuración de archivo
  archivo: {
    nombreBase: 'presupuesto',
    incluirFecha: true,
    incluirFolio: true,
    abrirAlGenerar: true
  },

  // Fuentes disponibles
  fuentes: {
    principal: 'Helvetica',
    secundaria: 'Times',
    monoespaciada: 'Courier'
  },

  // Configuración de compresión
  compresion: {
    comprimir: true,
    calidad: 0.75
  },

  // Metadatos del documento
  metadatos: {
    titulo: 'Presupuesto de Obra',
    autor: 'Sistema de Presupuestación',
    asunto: 'Presupuesto',
    palabrasClave: 'presupuesto, construcción, obra',
    creador: 'Sistema de Presupuestación v2.0'
  }
};

export default {
  pdfTemplates,
  getPdfTemplate,
  getAvailablePdfTemplates,
  customizePdfTemplate,
  pdfConfig
};